import { useEffect } from "react";

/** On phones/installed apps, pressing "back" from a portal home should do
 * NOTHING (users stay signed in; Sign out is the only exit). We push a
 * sentinel history entry and re-arm it whenever back pops it. */
export function useStayPut() {
  useEffect(() => {
    const standalone =
      window.matchMedia?.("(display-mode: standalone)")?.matches ||
      window.navigator.standalone === true;
    const mobile = /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent || "");
    if (!standalone && !mobile) return undefined;
    const arm = () => { try { window.history.pushState({ stayPut: true }, ""); } catch { /* ignore */ } };
    arm();
    const onPop = () => arm();
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
}
